export default __webpack_public_path__ + "1b745fc.png";